const { getSelectedLocale } = require('public/js/lib/locale-helper');
const NumberFormat = require('@revolutionparts/number-format');

const getNumberFormatter = function () {
	return NumberFormat(getSelectedLocale());
};

module.exports = {
	getNumberFormatter,
};